// src/services/printer/printQueueWorker.js
// import { multiPrinterService } from "./printer.service";
// import { printerConfigService } from "./printerConfigService";
// import { printQueueService } from "./printQueueService";

// class PrintQueueWorker {
//   constructor() {
//     this.isProcessing = false;
//     this.processingInterval = null;
//   }

//   // Iniciar el worker
//   start() {
//     if (!this.processingInterval) {
//       this.processingInterval = setInterval(() => this.processQueue(), 5000);
//       this.processQueue(); // Procesar inmediatamente al iniciar
//     }
//   }

//   // Detener el worker
//   stop() {
//     if (this.processingInterval) {
//       clearInterval(this.processingInterval);
//       this.processingInterval = null;
//     }
//   }

//   // Procesar la cola de impresión
//   async processQueue() {
//     if (this.isProcessing) return;

//     this.isProcessing = true;
//     try {
//       const pendingJobs = printQueueService.getPendingJobs();
//       console.log("[PrintQueueWorker] Trabajos pendientes:", pendingJobs);

//       for (const job of pendingJobs) {
//         try {
//           // Verificar si la impresora existe y está configurada
//           const printer = printerConfigService.printers.get(job.printerId);
//           if (!printer || !printer.config || !printer.config.isEnabled) {
//             console.log(
//               `[PrintQueueWorker] Impresora ${job.printerId} no disponible o deshabilitada`
//             );
//             continue;
//           }

//           console.log("[PrintQueueWorker] Procesando trabajo:", job.id);

//           // Intentar imprimir
//           await this.processPrintJob(job);

//           // Si la impresión fue exitosa, marcar como completado
//           printQueueService.markAsCompleted(job.id);
//           console.log("[PrintQueueWorker] Trabajo completado:", job.id);
//         } catch (error) {
//           console.error(
//             `[PrintQueueWorker] Error procesando trabajo ${job.id}:`,
//             error
//           );
//           printQueueService.markAsFailed(job.id, error);
//         }
//       }

//       // Limpiar trabajos antiguos después de procesar la cola
//       printQueueService.cleanupOldJobs();
//     } finally {
//       this.isProcessing = false;
//     }
//   }

//   // Procesar un trabajo de impresión específico
//   async processPrintJob(job) {
//     switch (job.type) {
//       case "KITCHEN_ORDER":
//         await multiPrinterService.printKitchenOrder(job.order, job.printerId);
//         break;

//       case "BAR_ORDER":
//         await multiPrinterService.printBarOrder(job.order, job.printerId);
//         break;

//       case "CUSTOMER_BILL":
//         await multiPrinterService.printCustomerBill(job.order, job.printerId);
//         break;

//       default:
//         throw new Error(`Tipo de impresión no soportado: ${job.type}`);
//     }
//   }
// }

// export const printQueueWorker = new PrintQueueWorker();
// src/services/printer/printQueueWorker.js
import { getPrinterService } from './MockPrinterService';
import { printerConfigService } from "./printerConfigService";
import { printQueueService } from "./printQueueService";

class PrintQueueWorker {
  constructor() {
    this.isProcessing = false;
    this.processingInterval = null;
    this.printerService = getPrinterService();
  }

  start() {
    const isTestMode = import.meta.env.VITE_PRINTER_MODE === 'test';
    if (!isTestMode && !this.processingInterval) {
      this.processingInterval = setInterval(() => this.processQueue(), 5000);
      this.processQueue();
    }
  }

  stop() {
    if (this.processingInterval) {
      clearInterval(this.processingInterval);
      this.processingInterval = null;
    }
  }

  async processQueue() {
    if (this.isProcessing) return;

    this.isProcessing = true;
    try {
      const pendingJobs = printQueueService.getPendingJobs();
     

      for (const job of pendingJobs) {
        try {
          const printer = printerConfigService.printers.get(job.printerId);
          if (!printer || !printer.config || !printer.config.isEnabled) {
           
            continue;
          }

        

          await this.processPrintJob(job);

          printQueueService.markAsCompleted(job.id);
         
        } catch (error) {
          console.error(
            `[PrintQueueWorker] Error procesando trabajo ${job.id}:`,
            error
          );
          printQueueService.markAsFailed(job.id, error);
        }
      }

      printQueueService.cleanupOldJobs();
    } finally {
      this.isProcessing = false;
    }
  }

  async processPrintJob(job) {
    switch (job.type) {
      case "KITCHEN_ORDER":
        await this.printerService.printKitchenOrder(job.order, job.printerId);
        break;

      case "BAR_ORDER":
        await this.printerService.printBarOrder(job.order, job.printerId);
        break;

      case "CUSTOMER_BILL":
        await this.printerService.printCustomerBill(job.order, job.printerId);
        break;

      default:
        throw new Error(`Tipo de impresión no soportado: ${job.type}`);
    }
  }
}

export const printQueueWorker = new PrintQueueWorker();